import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { SelectingType } from "./zonesSlice";

export type Type = "personal" | "linear" | "taxi_company" | "online_taxi";

interface IState {
  visible: boolean;
  marginParkShowType: number;
  markerMode: SelectingType[];
  heatmapMode: SelectingType;
  pointwiseShow: boolean;
  selectedZones: any[];
  selectedSubZones: any[];
}

const initialState: IState = {
  visible: false,
  marginParkShowType: 0,
  markerMode: ["source"],
  heatmapMode: "source",
  pointwiseShow: false,
  selectedZones: [],
  selectedSubZones: [],
};

export const marginParkSlice = createSlice({
  name: "marginPark",
  initialState,
  reducers: {
    changeTrafficShowType: (state, action: PayloadAction<number>) => {
      return { ...state, marginParkShowType: action.payload };
    },
    toggleVisibility: (state) => {
      return { ...state, visible: !state.visible };
    },
    makeInvisible: (state) => {
      return { ...state, visible: false };
    },
    changeMarkerMode: (state, action: PayloadAction<SelectingType[]>) => {
      return { ...state, markerMode: action.payload };
    },
    changeHeatMapMode: (state, action: PayloadAction<SelectingType>) => {
      return { ...state, heatmapMode: action.payload };
    },
    togglePointwiseShow: (state) => {
      return { ...state, pointwiseShow: !state.pointwiseShow };
    },
    changeSelectedZones: (state, action: PayloadAction<any>) => {
      return { ...state, selectedZones: [action.payload] };
    },
    changeSelectedSubZones: (state, action: PayloadAction<any>) => {
      console.log(action, "bhnergbgbh2");

      return { ...state, selectedSubZones: action.payload };
    },
    clearSelectedZones: (state) => {
      return { ...state, selectedZones: [], selectedSubZones: [] };
    },
  },
});

export const {
  changeTrafficShowType,
  toggleVisibility,
  makeInvisible,
  changeMarkerMode,
  changeHeatMapMode,
  togglePointwiseShow,
  changeSelectedZones,
  changeSelectedSubZones,
  clearSelectedZones,
} = marginParkSlice.actions;

export default marginParkSlice.reducer;
